<template>
  <div class="container">
    <div class="customer-study">
      <div class="customer-list-courses">
        <div class="title">
          <h4>Thông tin tổng quan</h4>
        </div>
        <div class="table-responsive overflow-auto">
          <table class="table table-vertical-center table-hover">
            <thead>
            <tr>
              <th>Khóa học</th>
              <th>Lớp học</th>
              <th>Lộ trình học</th>
              <th>Đi học</th>
              <th>Làm BTVN</th>
              <th>Tích luỹ năng lực</th>
              <th>Kết quả đầu ra</th>
              <th>Ngày khai giảng</th>
              <th>Ngày kết thúc</th>
              <th>Tình trạng bảo hành</th>
              <th>Hành động</th>
            </tr>
            </thead>
            <tbody v-if="studentRegisterCourses.length > 0">
            <tr v-for="(item) in studentRegisterCourses">
              <td>{{ item?.course_name ?? '' }}</td>
              <td>{{ item.classroom_name || '(Chưa có thông tin)' }}</td>
              <td>{{ item.schedule ?? '' }}</td>
              <td>{{ item?.schedule_number ?? '' }}</td>
              <td>{{ item.homework }}</td>

              <td>{{ item.capacity_building  }}</td>
              <td>
                <span :class="renderOutput(item.output).classText">{{ renderOutput(item.output).name }}</span>
              </td>
              <td>
                <span>{{ formatDate(item?.startDate) }}</span>
              </td>
              <td>
                <span>{{ formatDate(item?.endDate) }}</span>
              </td>
              <td>
                <template v-if="item.pass_guarantee && item.pass_guarantee.status == 2">
                  <div v-if="item.startDate && new Date(item.startDate).getTime() < Date.now()">
                    <el-tooltip
                        v-if="item.pass_guarantee.errors && item.pass_guarantee.errors.length > 0"
                        effect="dark"
                        placement="top"
                    >
                      <div slot="content">
                        <div
                            v-for="(error, index) in item.pass_guarantee.errors"
                            :key="index"
                        >
                          - {{ error.message }}
                        </div>
                      </div>

                      <el-button
                          size="small"
                          class="text-white rounded"
                          type="danger"
                      >
                        Mất bảo hành
                      </el-button>
                    </el-tooltip>

                    <el-button
                        v-else
                        size="small"
                        class="text-white rounded"
                        type="danger"
                    >
                      Mất bảo hành
                    </el-button>
                  </div>
                </template>

                <el-button
                    v-else
                    size="small"
                    class="text-white rounded"
                    type="success"
                >
                  Pass bảo hành
                </el-button>
              </td>
              <td>
                <a href="#" title="Xem chi tiết"
                   class="btn btn-xs btn-icon btn-outline-success ml-2"
                   @click="showModalDetail(item)"><i class="far fa-eye"></i>
                </a>

                <a href="#" title="Thay đổi điều kiện bảo hành" v-if="item?.startDate"
                   class="btn btn-xs btn-icon btn-outline-primary ml-2"
                   @click="changeWarrantyConditions(item)"><i class="el-icon-edit-outline"></i>
                </a>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="8" class="event-title no-data text-center">Chưa có dữ liệu</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
<!--          <pre>{{studentRegisterCourse}}</pre>-->
          <test-result :tests="tests" :student_name="student_name"></test-result>
        </div>
      </div>
    </div>
    <el-dialog title="Tình hình học tập" :visible.sync="showModal">
      <chi-tiet-hoc-tap
          :loading="loading"
          :student-register-course="studentRegisterCourse"
          :classroom="classroomShow"
          :schedules="schedules"
          :center-id ="centerId"
      ></chi-tiet-hoc-tap>
    </el-dialog>
  </div>
</template>

<script>
import ChiTietHocTap from "./ChiTietHocTap";
import {CUSTOMER_SCHEDULE_LIST, CHANGE_WARRANTY_CONDITION} from "@/core/services/store/customer/customer-crm.module";
import {StudyDetail} from "@/view/pages/customers/Model/studyDetail";
import moment from "moment-timezone";
import WarrantyTooltip from "../components/WarrantyTooltip.vue";
import TestResult from "../components/TestResult";
import Swal from "sweetalert2";

export default {
  name: "Hoc-Tap",
  components: {WarrantyTooltip, ChiTietHocTap, TestResult},
  props: {
    studentRegisterCourses: {
      type: Array,
      default: () => {
        return []
      }
    },
    tests: {
      type: Array,
      default: () => {
        return []
      }
    },
    student_name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      studentRegisterCourse: {},
      classroomShow: {},
      schedules: [],
      loading: true,
      centerId : 0,
    }
  },
  watch: {
    showModal() {
      if (this.showModal === false) {
        this.schedules = []
        this.loading = true
      }
    }
  },
  methods: {
    showModalDetail(studentRegisterCourse) {
      this.studentRegisterCourse = studentRegisterCourse;
      this.classroomShow = studentRegisterCourse.class;
      this.showModal = true;
      this.getSchedule();
    },
    getSchedule() {
      try {
        this.$store.dispatch(CUSTOMER_SCHEDULE_LIST, this.studentRegisterCourse.id).then((res) => {
          if (res?.data === null) {
            this.schedules = []
            this.loading = false
            return
          }
          const result = res?.data?.result
          this.centerId = res?.data?.center_id
          this.schedules = result.map(item => new StudyDetail(
              item?.lesson,
              item?.day,
              item?.attendance_value,
              item?.rating,
              item?.homework_status,
              item?.teacher_comment,
              item?.comment_phase,
              item?.type,
              result?.length,
              item?.student_feedback,
              item?.comment,
              item?.attendance_reason,
              item?.schedule_type,
              item?.capacity_building,
              item?.tooltip,
              item?.type_comment_phase,
              item?.lesson_alias,
              item?.version,
              item?.classroom_id
          ));
          this.loading = false
        }).catch(e => {
          console.log(e)
        })
      } catch (error) {
        console.log(error)
      }
    },
    formatDate(value) {
      if (!value) return ''
      return moment(value).format('DD-MM-YYYY')
    },
    renderOutput(output) {
      let text;
      let classText;
      switch (output) {
        case 1:
          text = 'Pass';
          classText = 'badge bg-green';
          break;
        case 2:
          text = 'Fail';
          classText = 'badge badge-info';
          break;
        default:
          text = 'Chưa có';
      }
      return {
        name: text,
        classText: classText
      };
    },

    async changeWarrantyConditions(item) {
      const currentStatus = Number(item?.pass_guarantee?.status ?? 0)
      const nextStatus = currentStatus === 2 ? 1 : 2

      const result = await Swal.fire({
        title: 'Xác nhận thay đổi',
        text: `Bạn có chắc muốn ${nextStatus ? 'bật' : 'tắt'} điều kiện bảo hành không?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Huỷ',
        reverseButtons: true
      })

      if (!result.isConfirmed) {
        return
      }

      const payload = {
        student_register_course_id : item.id ?? null,
        next_status : nextStatus
      };

      await this.$store.dispatch(CHANGE_WARRANTY_CONDITION, payload).then((res) => {
        if(!res.error) {
          this.$emit('change-warranty-condition', item.id, payload.next_status )
          this.$message.success('Cập nhật điều kiện bảo hành thành công')

        }

      }).catch(e => {
        this.$message.error(e?.data?.message || 'Cập nhật điều kiện bảo hành thất bại')
      })
    }
  }
}
</script>

<style scoped>
.bg-green {
  background: #128300;
  color: white;
}

.bg-blue {
  color: white;
  background: #1BC5BD
}

.bg-gray {
  background: #6C6C6C;
  color: white;
}

.el-tooltip__popper {
  max-width: 250px;
  line-height: 1.6;
}
</style>
